<template>
    <pc-page-layout
        ref="layout"
        v-bind:programs="Programs"
        v-bind:show-program-selector="ShowProgramSelector"
        v-bind:waiting="waiting">
        <pc-page-header v-bind:header="header" />
        <hr />
        <div class="mb-3">
            {{ instructionText }}
        </div>
        <div class="row mb-3">
            <div class="col-12 col-lg-6">
                <pc-input
                    id="emailInput"
                    v-model="resetEmail"
                    v-bind:label="emailInputLabel"
                    v-bind:validator="resetEmailValidator"
                    v-bind:external-native-handlers="{ keyup: onResetPasswordEnter }"
                    v-bind:placeholder="emailPlaceholder"
                    immediate-validation
                    inputmode="email"
                    class="flex-grow-1"
                    v-on:validated="onValidated" />
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between">
            <pc-recaptcha
                ref="recaptcha"
                class="mr-auto" />
            <pc-button
                id="submitPasswordReset"
                v-bind:disabled="!canSendResetLink"
                primary
                v-on:click="sendResetLink">
                {{ sendResetLinkBtnLabel }}
            </pc-button>
        </div>
        <pc-alert
            v-model:shown="showAlert"
            v-bind:duration="0"
            v-bind:severity="alertSeverity"
            v-bind:message="alertMessage"
            v-bind:title="alertTitle"
            class="mt-3 mb-0" />
    </pc-page-layout>
</template>
<script>
    import pageBase from "Components/page/_page-base.js";
    import { ALERT_SEVERITY, ALERT_DURATION } from "Util/alerts";
    import { getValidator, VALIDATOR_TYPES } from "Validation/validator";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/forgotPassword.i18n";
    import pcRecaptcha from "Components/pc-recaptcha.vue";

    export default {
        name: "ForgotPassword",
        components: {
            pcRecaptcha
        },
        extends: pageBase,
        setup: pageBase.setup,
        data() {
            return {
                resetEmail: null,
                resetSending: false,

                showAlert: false,
                alertSeverity: ALERT_SEVERITY.info,
                alertMessage: null,
                alertTitle: null,

                validationResult: null
            };
        },
        computed: {
            resetEmailValidator() {
                return getValidator(this.$app, VALIDATOR_TYPES.email);
            },
            canSendResetLink() {
                return this.resetEmail && !this.hasValidationError;
            },
            hasValidationError() {
                return this.validationError != null;
            },
            validationError() {
                if (this.validationResult) {
                    return this.validationResult.error;
                }
                return null;
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        methods: {
            async onLoaded(model) {
                this.$refs.recaptcha.init(model.GRecaptchaSiteKey);
            },
            async sendResetLink() {
                this.showAlert = false;

                if (!this.canSendResetLink) {
                    return;
                }

                if (this.resetSending) {
                    return;
                }

                const captchaResponse = this.$refs.recaptcha.getRecaptchaResponse();
                if (!captchaResponse) {
                    this.alertMessage = this.$refs.recaptcha.recaptchaRequiredAlertText;
                    this.showAlert = true;
                    return;
                }

                this.blockUi();
                this.resetSending = true;
                try {
                    const result = await this.SendPasswordResetEmail({
                        email: this.resetEmail,
                        programId: this.ProgramId,
                        captchaString: captchaResponse
                    });
                    if (result.status === "success") {
                        this.unBlockUi();

                        this.alertMessage = this.successAlertText;
                        this.alertSeverity = ALERT_SEVERITY.success;
                        this.alertTitle = this.successAlertTitle;
                        this.showAlert = true;

                        await this.timeout(ALERT_DURATION.long);
                        this.setHref(this.Model.LoginPageUrl);
                    }
                } finally {
                    this.$refs.recaptcha.resetRecaptcha();
                    this.showAlert = false;
                    this.resetSending = false;
                    this.unBlockUi();
                }
            },
            onValidated(validationResult) {
                this.validationResult = validationResult;
            },
            onResetPasswordEnter(event) {
                if (this.validationError == null && (event.key == "Enter" || event.keyCode == 13)) {
                    this.sendResetLink();
                }
            }
        }
    };
</script>
